import React from 'react';

import Balance from '../Balance';
import Logo from '../Logo';
import Menu from '../Menu';
import WebmasterMenu from '../WebmasterMenu';

import styles from './styles/index.css.json';


export default () => (
  <div className={styles.header}>
    <div className={styles.header__topLevel}>
      <div className={styles.header__logo}>
        <Logo />
      </div>

      <div className={styles.header__balance}>
        <Balance />
      </div>

      <div className={styles.header__webmasterMenu}>
        <WebmasterMenu />
      </div>
    </div>
    <div className={styles.header__bottomLevel}>
      <Menu />
    </div>
  </div>
);
